import { render, staticRenderFns } from "./Manpower.vue?vue&type=template&id=53dbebe0&"
import script from "./Manpower.vue?vue&type=script&lang=js&"
export * from "./Manpower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports